import bg from '../assets/bg.webp';
import chef from '../assets/gustavo.webp';
import G from '../assets/G.webp';
import gallery01 from '../assets/1.webp';
import gallery02 from '../assets/2.webp';
import gallery03 from '../assets/3.webp';
import gallery04 from '../assets/4.webp';
import gallery05 from '../assets/gallery05.webp';
import gallery06 from '../assets/gallery06.webp';
import gallery07 from '../assets/gallery07.webp';
import gallery08 from '../assets/gallery08.webp';
import gallery09 from '../assets/gallery09.webp';
import knife from '../assets/microfono.webp';
import menu from '../assets/menu.webp';
import overlaybg from '../assets/overlaybg.webp';
import spoon from '../assets/spoon.svg';
import findus from '../assets/ESPECIAL.webp';
import laurels from '../assets/VIP.webp';
import award01 from '../assets/award01.webp';
import award02 from '../assets/award02.webp';
import award03 from '../assets/award03.webp';
import award05 from '../assets/award05.webp';
import sign from '../assets/sign.webp';
import quote from '../assets/quote.webp';
import logos from '../assets/logo.webp';
import welcome from '../assets/imagen1.webp';
import lujo from '../assets/LUJO.webp';
import basic from '../assets/basic.webp';
import grupo from '../assets/grupo.webp';
export default {
  bg,
  chef,
  G,
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  gallery05,
  gallery06,
  gallery07,
  gallery08,
  gallery09,
  knife,
  menu,
  overlaybg,
  spoon,
  welcome,
  findus,
  laurels,
  award01,
  award02,
  award03,
  award05,
  sign,
  quote,
  logos,
  lujo,
  basic,
  grupo
};
